import Page from "@/views/Page";
import VueRouter from "vue-router";

let routes = [
    {
        path: '/',
        component: Page
    },
];

const router = new VueRouter({
    mode: 'history',
    routes: routes // short for `routes: routes`
})

export default router;